const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  info: {
    fontSize: "10pt",
    width: "600px",
    textAlign: "left"
  },
  image: {
    height: "120px",
    width: "290px",
    maxHeight: "120px",
    maxWidth: "290px",
    minHeight: "120px",
    minWidth: "290px"
  },
  image2: {
    height: "200px",
    width: "220px",
    objectFit: "contain",
    transform: "translateY(-65px)"
  },
  image3: {
    height: "180px",
    width: "290px",
    maxHeight: "180px",
    maxWidth: "290px",
    minHeight: "180px",
    minWidth: "290px"
  },
  info_div: {
    display: "flex",
    paddingLeft: "5%",
    paddingTop: "0%",
    transform: "translateY(-140px)"
  },
  info_div_without_speed: {
    display: "flex",
    paddingLeft: "5%",
    paddingTop: "0%"
  },
  imageContainer: {
    justifyContent: "center",
    alignItems: "center"
  }
});

export default styles;
